import React, { Component } from 'react';
import NavMenu from './NavMenu';
import { ToastContainer, toast } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css';

export class Layout extends Component {
    static displayName = Layout.name;

    render() {
        return (
            <>
                <header className="container">
                    <img src="images/ninkn-logo.jpg" alt=""/>
                </header>
                <ToastContainer position={toast.POSITION.TOP_LEFT} autoClose={2000} hideProgressBar={true} /> 
                <main>
                    {this.props.children}


                </main>
                <footer style={{ 'display': 'flex'}}>
                    <img src="images/prog-flag1.png" className="prog-img flex-img1" alt="" />
                    <p className="prog-text">
                        Тази платформа е създаден в рамките на проект „Дигитализация на архива на недвижимите
                        културни ценности от световно и национално значение, изграждане на специализирана информационна система,
                        електронен регистър и публичен портал“, който се осъществява с финансовата подкрепа на Оперативна
                        програма
                        „Добро управление” 2014-2020 г., съфинансирана от Европейския съюз чрез Европейския социален фонд
            </p>
                    <img src="images/prog-flag2.png" className="prog-img flex-img2" alt=""/>
                </footer>


                <NavMenu></NavMenu>




            </>
        );
    }
}
